import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import Cookies from "js-cookie";
import getters from "./getters";
import actions from "./actions";
import mutations from "./mutatios";

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    user_id: "",
    me: null,
    integrations: [],
    invitations: [],
    organization: null,
    requests: [],
    scheduling: {
      settings: {},
      availability: [],
      events: [],
      embeds: [],
      pendings: [],
      polls: [],
    },
  },
  getters,
  mutations,
  actions,
  plugins: [
    createPersistedState({
      storage: {
        getItem: (key) => Cookies.get(key),
        setItem: (key, value) => Cookies.set(key, value, { secure: false }), // set true when app is done
        removeItem: (key) => Cookies.remove(key),
      },
    }),
  ],
});

export default store;
